export default class PadreFilter{
	constructor(){
		// data es el array a filtrar
		// idMatch es la id para hacer match
		// nombreVariable es la variable
		return (data, idMatch, nombreVariable) => {
			if (data !== undefined &&
				idMatch !== undefined &&
				nombreVariable !== undefined) {
				let out = [];
				data.filter((item) => {
					if (item[nombreVariable]._id == idMatch) {
						out.push(item);
					}
				});
				return out;
			}
		}
	}

	static filter(){
		return new PadreFilter();
	}
}



// WEBPACK FOOTER //
// ./app/js/filters/padreFilter.js